import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAccount, useConnect, useSignMessage } from "wagmi";
import { useAuth } from "../../context/AuthContext";
import { SITE_DASHBOARD_PATH } from "../../constants/siteNavRoutes";

const SIGN_IN_HELPER_COPY =
  "Sign a message to enter Treydora. This does not cost gas and does not give permission to move funds.";

export default function AuthPageWalletSignIn() {
  const { walletLogin } = useAuth();
  const navigate = useNavigate();
  const { address, isConnected } = useAccount();
  const { connectAsync, connectors } = useConnect();
  const { signMessageAsync } = useSignMessage();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [hint, setHint] = useState("");

  const ensureConnectedAddress = async () => {
    let activeAddress = address;
    if (!isConnected || !activeAddress) {
      const list = Array.isArray(connectors) ? connectors : [];
      const connector = list.find((c) => c && c.ready) || list[0];
      if (!connector) {
        throw new Error(
          "No wallet connector available. Install a browser wallet or enable WalletConnect."
        );
      }
      const connected = await connectAsync({ connector });
      activeAddress = connected?.account;
    }
    if (!activeAddress) {
      throw new Error("Wallet not connected.");
    }
    return activeAddress;
  };

  const onWalletLogin = async () => {
    setBusy(true);
    setErr("");
    setHint("");
    try {
      const activeAddress = await ensureConnectedAddress();
      setHint(SIGN_IN_HELPER_COPY);
      await walletLogin({
        walletAddress: activeAddress,
        signMessageAsync,
      });
      setHint("");
      navigate(SITE_DASHBOARD_PATH, { replace: true });
    } catch (e) {
      const msg =
        e?.shortMessage ||
        e?.message ||
        (typeof e === "string" ? e : "Unable to sign in with this wallet.");
      if (/rejected|denied|user rejected/i.test(String(msg))) {
        setErr("Signature was rejected in the wallet.");
      } else {
        setErr(String(msg));
      }
    } finally {
      setBusy(false);
      setHint("");
    }
  };

  return (
    <div className="td-auth-page__wallet">
      {hint ? (
        <p className="td-auth-page__hint" role="status">
          {hint}
        </p>
      ) : null}
      {err ? (
        <p className="td-auth-page__err" role="alert">
          {err}
        </p>
      ) : null}
      <button
        type="button"
        className="oshar-btn-gold td-auth-page__wallet-btn"
        disabled={busy}
        onClick={() => onWalletLogin()}
      >
        {busy ? "Signing…" : "Sign in with wallet"}
      </button>
      <p className="td-auth-page__wallet-note">
        Wallet-only sign-in? Add an email later for receipts and account recovery when your account
        settings support it.
      </p>
    </div>
  );
}
